module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-right.fc358951.svg";